import { fetchUserWinCriteria, userHasWinCriteria } from '@/utils/winCriteriaGate'

export const LEGACY_GLOBAL_KEY_ID = '67ff9d835e691147bf1baf4f'

const LEGACY_SKIP_PREFIX = 'setup_onboarding_skipped_'

const DEFAULT_KEY_NAME_PATTERNS = [
  /^глобальн/i,
  /^по умолчанию/i,
  /^default$/i,
  /^новый ключ/i,
  /^поисковый ключ$/i,
]

function parseWordsValue(key) {
  const raw = key?.words?.value
  if (!raw) return []
  if (Array.isArray(raw)) return raw.map((s) => String(s).trim()).filter(Boolean)
  return String(raw)
    .split(/[,;]/)
    .map((s) => s.trim())
    .filter(Boolean)
}

function isDefaultKeyName(name) {
  const n = String(name ?? '').trim()
  if (!n) return true
  return DEFAULT_KEY_NAME_PATTERNS.some((re) => re.test(n))
}

export function normalizeKeysList(data) {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.results)) return data.results
  return []
}

export function getPrimaryUserKey(keys) {
  const list = normalizeKeysList(keys)
  if (!list.length) return null
  const nonLegacy = list.filter((k) => {
    const id = String(k._id ?? k.id ?? '')
    return id && id !== LEGACY_GLOBAL_KEY_ID
  })
  return nonLegacy[0] ?? null
}

export function isLegacyGlobalKey(keyOrId) {
  const id = typeof keyOrId === "object" && keyOrId != null
    ? String(keyOrId._id ?? keyOrId.id ?? "")
    : String(keyOrId ?? "")
  return id === LEGACY_GLOBAL_KEY_ID
}

export function userKeyIsPersonalized(key) {
  if (!key) return false
  const id = String(key._id ?? key.id ?? '')
  if (id === LEGACY_GLOBAL_KEY_ID) return false
  if (key.is_personalized === true) return true
  const words = parseWordsValue(key)
  if (!words.length) return false
  return !isDefaultKeyName(key.name)
}




export async function fetchUserKeys(api) {
  const { data } = await api.get('/keys/')
  return normalizeKeysList(data)
}

/** Removes legacy permanent-skip localStorage keys. */
export function clearLegacySetupSkip(userId) {
  if (userId == null || userId === '') return
  try {
    localStorage.removeItem(`${LEGACY_SKIP_PREFIX}${userId}`)
  } catch (_) {}
}

export async function checkNeedsSetup(api, { userId, force = false } = {}) {
  if (userId != null) clearLegacySetupSkip(userId)

  const [rows, keys] = await Promise.all([
    fetchUserWinCriteria(api, { force }),
    fetchUserKeys(api),
  ])

  const hasCriteria = userHasWinCriteria(rows)
  const primaryKey = getPrimaryUserKey(keys)
  const keyPersonalized = userKeyIsPersonalized(primaryKey)

  return {
    needsSetup: !hasCriteria || !keyPersonalized,
    skipped: false,
    hasCriteria,
    keyPersonalized,
    primaryKey,
    keys,
  }
}

export function emitSetupCompleted() {
  window.dispatchEvent(new CustomEvent('setup-completed'))
}